"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateOfferLink = exports.ClickContext = void 0;
const zod_1 = require("zod");
const types_1 = require("../types");
exports.ClickContext = zod_1.z.object({
    ip: zod_1.z.string(),
    userAgent: zod_1.z.string(),
    clickId: zod_1.z.string(),
    userId: zod_1.z.string(),
    adId: zod_1.z.string(),
    mmpProvider: types_1.MMPProviderEnum,
    mmpLink: zod_1.z.string(),
    isUAOffer: zod_1.z.boolean(),
    campaignName: zod_1.z.string(),
    campaignId: zod_1.z.string(),
    offerId: zod_1.z.string(),
    subSourceId: zod_1.z.string(),
});
const escapeRegExp = (str) => {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
};
// string.replaceAll(..) replacement for older browsers https://stackoverflow.com/questions/1144783/how-do-i-replace-all-occurrences-of-a-string-in-javascript
const replaceAll = (str, find, replace) => {
    return str.replace(new RegExp(escapeRegExp(find), 'g'), replace);
};
const MMP_REPLACE_CONSTS = {
    PUBLISHER_ID: '1001',
    UA_OFFER_SUB_SITE_ID: 2001,
    NON_UA_OFFER_SUB_SITE_ID: 2002,
};
const generateOfferLink = (mmpLinkDetails) => {
    switch (mmpLinkDetails.mmpProvider) {
        case types_1.MMPProvider.NONE:
            return mmpLinkDetails.mmpLink;
        case types_1.MMPProvider.APPSFLYER:
            return generateAppsFlyerMMPURL(mmpLinkDetails);
        case types_1.MMPProvider.MOTIVE:
            return generateMotiveMMPURL(mmpLinkDetails);
        case types_1.MMPProvider.SINGULAR:
            return generateSingularLink(mmpLinkDetails);
        case types_1.MMPProvider.ADJUST:
            return generateAdjustLink(mmpLinkDetails);
        case types_1.MMPProvider.BITLAB:
            return generateBitlabMMPURL(mmpLinkDetails);
        case types_1.MMPProvider.BESITOS:
        case types_1.MMPProvider.PERFORM_CB:
        case types_1.MMPProvider.HANG_MY_ADS:
        case types_1.MMPProvider.AD_ACTION:
        case types_1.MMPProvider.FEEDMOB:
        default: {
            return generateDefaultMMPURL(mmpLinkDetails);
        }
    }
};
exports.generateOfferLink = generateOfferLink;
const generateAppsFlyerMMPURL = (mmpLinkDetails) => {
    const encodedCampaignName = encodeURIComponent(mmpLinkDetails.campaignName);
    const subSiteId = getSubSiteId(mmpLinkDetails.isUAOffer);
    const mmpLink = mmpLinkDetails.mmpLink
        // for this one we include the = because the made the ip identifier the same
        .replace(/(=ip)/g, `=${mmpLinkDetails.ip}`)
        .replace('pbrid', mmpLinkDetails.userId)
        .replace('user_agent', encodeURIComponent(mmpLinkDetails.userAgent))
        .replace('click_id', mmpLinkDetails.clickId)
        .replace('{adid}', mmpLinkDetails.adId)
        .replace('adid', mmpLinkDetails.adId)
        .replace('sub_site_id', subSiteId.toString())
        .replace('{sub_source_id}', mmpLinkDetails.subSourceId)
        .replace('campaign_name', encodedCampaignName)
        .replace('campaign_id', mmpLinkDetails.campaignId)
        .replace('{offerid}', mmpLinkDetails.offerId);
    return mmpLink;
};
const generateMotiveMMPURL = (mmpLinkDetails) => {
    const encodedCampaignName = encodeURIComponent(mmpLinkDetails.campaignName);
    const mmpLink = mmpLinkDetails.mmpLink
        .replace('click_id', mmpLinkDetails.clickId)
        .replace('{adid}', mmpLinkDetails.adId)
        .replace('adid', mmpLinkDetails.adId)
        .replace('campaign_name', encodedCampaignName)
        .replace('{offerid}', mmpLinkDetails.offerId);
    return mmpLink;
};
const generateBitlabMMPURL = (mmpLinkDetails) => {
    const encodedCampaignName = encodeURIComponent(mmpLinkDetails.campaignName);
    let mmpLink = replaceAll(mmpLinkDetails.mmpLink, '{campaign_name}', encodedCampaignName);
    mmpLink = replaceAll(mmpLink, '{adid}', mmpLinkDetails.adId);
    mmpLink = replaceAll(mmpLink, '{offerid}', mmpLinkDetails.offerId);
    mmpLink += `${mmpLinkDetails.userId}&s3=${mmpLinkDetails.clickId}`;
    return mmpLink;
};
const generateDefaultMMPURL = (mmpLinkDetails) => {
    const encodedCampaignName = encodeURIComponent(mmpLinkDetails.campaignName);
    let mmpLink = mmpLinkDetails.mmpLink;
    mmpLink = replaceAll(mmpLink, '{click_id}', mmpLinkDetails.clickId);
    mmpLink = replaceAll(mmpLink, '{google_adid}', mmpLinkDetails.adId);
    mmpLink = replaceAll(mmpLink, '{adid}', mmpLinkDetails.adId);
    mmpLink = replaceAll(mmpLink, '{user_id}', mmpLinkDetails.userId);
    mmpLink = replaceAll(mmpLink, '{campaign_name}', encodedCampaignName);
    mmpLink = replaceAll(mmpLink, '{campaign_id}', mmpLinkDetails.campaignId);
    mmpLink = replaceAll(mmpLink, '{user_agent}', encodeURIComponent(mmpLinkDetails.userAgent));
    mmpLink = replaceAll(mmpLink, '{ip}', mmpLinkDetails.ip);
    mmpLink = replaceAll(mmpLink, '{click_time_iso}', new Date().toISOString());
    mmpLink = replaceAll(mmpLink, '{sub_source_id}', mmpLinkDetails.subSourceId);
    mmpLink = replaceAll(mmpLink, '{offerid}', mmpLinkDetails.offerId);
    return mmpLink;
};
const generateSingularLink = (mmpLinkDetails) => {
    const encodedCampaignName = encodeURIComponent(mmpLinkDetails.campaignName);
    const subSiteId = getSubSiteId(mmpLinkDetails.isUAOffer);
    const mmpLink = mmpLinkDetails.mmpLink
        .replace('{click_id}', mmpLinkDetails.clickId)
        .replace('{sub_source_id}', mmpLinkDetails.subSourceId)
        .replace('{user_agent}', encodeURIComponent(mmpLinkDetails.userAgent))
        .replace('{sub_site_id}', subSiteId.toString())
        .replace('{user_id}', mmpLinkDetails.userId)
        .replace('{adid}', mmpLinkDetails.adId)
        .replace('{ip}', mmpLinkDetails.ip)
        .replace('{campaign_name}', encodedCampaignName)
        .replace('{campaign_id}', mmpLinkDetails.campaignId)
        .replace('{offerid}', mmpLinkDetails.offerId);
    return mmpLink;
};
const generateAdjustLink = (mmpLinkDetails) => {
    const encodedCampaignName = encodeURIComponent(mmpLinkDetails.campaignName);
    const subSiteId = getSubSiteId(mmpLinkDetails.isUAOffer);
    let mmpLink = mmpLinkDetails.mmpLink
        .replace('{campaign_name}', encodedCampaignName)
        .replace('{ip}', mmpLinkDetails.ip)
        .replace('{sub_site_id}', subSiteId.toString())
        .replace('{gaid}', mmpLinkDetails.adId);
    mmpLink = replaceAll(mmpLink, '{sub_source_id}', mmpLinkDetails.subSourceId);
    mmpLink = replaceAll(mmpLink, '{click_id}', mmpLinkDetails.clickId);
    mmpLink = replaceAll(mmpLink, '{pbrid}', mmpLinkDetails.userId);
    mmpLink = replaceAll(mmpLink, '{adid}', mmpLinkDetails.adId);
    mmpLink = replaceAll(mmpLink, '{offerid}', mmpLinkDetails.offerId);
    return mmpLink;
};
const getSubSiteId = (isUAOffer) => {
    return isUAOffer
        ? MMP_REPLACE_CONSTS.UA_OFFER_SUB_SITE_ID
        : MMP_REPLACE_CONSTS.NON_UA_OFFER_SUB_SITE_ID;
};
